import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { ImageStyleProps } from '../contentful-elements/Image';
import LazyLoadStyle from './LazyLoadStyle';
import PropsComponent from './types/PropsComponent';

const Section = styled.section`
  position: relative;
  width: 100%;
`;

const BackgroundImageStyles = css`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
  top: 0;
  left: 0;
  object-fit: cover;
`;

type Props = {
  id?: string;
  Image?: PropsComponent<ImageStyleProps>;
  backgroundColor?: string;
  backgroundLinear?: string;
  children?: ReactNode;
  overlay?: number;
};

const Headliner = ({ id, Image, backgroundColor, backgroundLinear, children, overlay }: Props) => {
  return (
    <Section id={id}>
      <div
        css={css`
          z-index: -1;
          position: absolute;
          height: 98vh;
          max-height: 800px;
          width: 100%;
        `}
      >
        <div
          css={css`
            position: relative;
            height: 100%;
            width: 100%;
            background-color: ${backgroundColor || `rgba(0,0,0,${(overlay || 0) / 100})`};
            background-image: ${backgroundLinear};
            background-size: cover;
          `}
        >
          {Image && (
            <LazyLoadStyle>
              <Image
                css={BackgroundImageStyles}
                aspectRatios={{ mobile: 9 / 16, tablet: 16 / 9 }}
              />
            </LazyLoadStyle>
          )}
        </div>
      </div>
      {children}
    </Section>
  );
};

export default Headliner;
